<!doctype html>
<html lang="en">
    <head>
        <script lang="ts">
            // This is used to track requests that come from a browser.
            document.cookie = 'client=goodxweb';

            // Inline the watchdog - see file for more details.
            // This must be the first script to execute.
            <!-- @include ./src/bootstrap-watchdog.ts -->
        </script>

        <meta charset="UTF-8">
        <meta name="description" content="GoodX Web - Online Booking and Debtor Account Management">
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=yes">

        <link rel="icon" href="/images/favicon.ico" type="image/x-icon">
        <title>GoodX Web</title>

        <!-- The LoadScreen must display asap - inline its css. -->
        <style>
            <!-- @include ./src/screens/LoadScreen/LoadScreen.standalone.less?inline -->
        </style>

        <!-- The plugin-async-css plugin makes stylesheets load async and non-render-blocking. -->
        <link rel="stylesheet" href="/static/css/bootstrap.css">
        <link rel="stylesheet" href="/static/css/font-awesome.min.css">
        <link rel="stylesheet" href="/static/css/ionicons.min.css">
        <link rel="stylesheet" href="/static/css/jquery-ui.min.css">
        <link rel="stylesheet" href="src/main.less">
    </head>
    <body>
        <!-- The LoadScreen must display asap - inline its html. -->
        <div class="LoadScreen" data-bind="nobind">
            <!-- @include ./src/screens/LoadScreen/LoadScreen.html -->
        </div>

        <script>
            // if it's a mobile device, force to desktop mode.
            if (screen.width < 768) {
                document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=992');
            }
        </script>

        <script type="module" src="src/bootstrap.ts"></script>

        <script defer src="/static/js/Recorder/recorder.min.js"></script>
        <script defer src="/static/js/bootstrap.min.js"></script>
        <script>
            window.initMap = function() {
                delete window.initMap;
            }
        </script>
        <script src="/getGoogleApiUrl?callback=initMap" async></script>
    </body>
</html>
